import { ALL_REGIONS } from '../api/constants';
import { Area, IHeaderMenuWithSubMenu, IUserInfo } from '../Types/types';
export const FOOTER_TEXT =
  '© Shell Energy Integration & Fundamentals (SEIF) Carbon Portfolio Management. ';
export const FOOTER_SUB_TEXT = 'Confidential data and graphs. Not for onward distribution.';
export const WELCOME_TITLE = 'Welcome to the';
export const CARBON_DASHBOARD = 'Carbon Dashboard ';
export const LINK_TEXT = 'How do we calculate carbon budget?';
export const STATUS_TITLE = 'Status';
export const STATUS_SUB_TITLE = 'Executive Summary.';
export const TOTAL_CARBON_EMISSION = 'Total Carbon Emissions';
export const NET_CARBON_INTENSITY = 'Net Carbon Intensity';
export const AVG_PLANNING_MCR_IPU = 'Average Planning MCR per IPU';
export const BUSINESS_SPLIT_TITLE = 'Business Split';
export const BUSINESS_SPLIT_SUB_TITLE = 'In Scope Volume per Integrated Performance Unit (TWh).';
export const MARGIN_TO_CARBON_RATIO = 'Margin to Carbon Ratio';
export const COMMODITY_SPLIT_TITLE = 'Commodity Split';
export const COMMODITY_SPLIT_SUB_TITLE =
  'Current year Net Absolute Emissions per commodity (mtpa).';
export const emailList = [
  'swati.tyagi@shell.com',
  'm.sunnypanguluri@shell.com',
  'katherine.langworthy@shell.com',
  'yifan.y.wang@shell.com',
  'james.perkins2@shell.com',
  'rama-prasad.nayak@shell.com',
  'md.m.irfan@shell.com',
  'camilla.torre@shell.com',
  'nitish.n.raj@shell.com',
  'sk-sabir.ali@shell.com',
  'amit.sarur@shell.com',
  'binu-jose.zachariah@shell.com',
  'abhilasha.kanaskar@shell.com',
];
export const CARBON_EMISSION = 'CARBON_EMISSION';
export const QUANTITY = 'QUANTITY';
export const CARBON_BUDGET = 'CARBON_BUDGET';
export const MARGIN_CARBON_RATIO = 'MARGIN_CARBON_RATIO';
export const PLANNING_ONE_SOURCE = 'PlanningOne';
export const PARIGFINANCEREPORT = 'PARIGFinance&Reporting';
export const PUBLISH = 'Publish';
export const UPDATED_ON = 'Updated on';
export const ENTER_EXECUTIVE_SUMMARY = 'Enter executive summary';
export const R_ES_GLOBAL_COE_CORP = 'R&ES Global COE & Corporate';
export const COMMODITY_OVERVIEW = 'Commodity Overview';
export const SCENARIO_MODELLING = 'Scenario Modelling';
export const USER_DATA: IUserInfo = {
  at_hash: 'abcdef',
  aud: 'example_audience',
  auth_time: 1631500000,
  azp: 'example_azp',
  email: 'user@example.com',
  email_verified: true,
  exp: 1631600000,
  iat: 1631500000,
  iss: 'example_issuer',
  jti: 'example_jti',
  preferred_username: 'example_user',
  session_state: 'example_session',
  sid: 'example_sid',
  sub: '12345',
  typ: 'example_type',
  scope: 'test',
  allowed_origins: [],
  realm_access: { roles: [] },
  resource_access: { account: { roles: [] } },
  user: {
    at_hash: 'Ty3r8SYikbz0SoOPtS5YdQ',
    aud: 'TANSO_LOCAL',
    auth_time: 1694583446,
    azp: 'TANSO_LOCAL',
    email: 'md.m.irfan@shell.com',
    email_verified: false,
    exp: 1694584535,
    iat: 1694584235,
    iss: 'https://sso.dep.shell/auth/realms/dep',
    jti: 'c71197c2-bec2-4be3-babc-31f0328b8136',
    preferred_username: 'inmir5',
    session_state: '82d81ef8-278e-4801-b07e-f014f731a694',
    sid: '82d81ef8-278e-4801-b07e-f014f731a694',
    sub: '533eb9f9-1ced-44c5-8536-5375c737ea0f',
    typ: 'ID',
    scope: 'test',
    allowed_origins: [],
    realm_access: { roles: [] },
    resource_access: { account: { roles: [] } },
  },
};
export const LOGOUT = 'logout';
export const TITLE_DASHBOARD = 'CPM';
export const SUB_TITLE_DASHBOARD = 'Shell Energy';
export const TABS_MENU = [
  {
    key: 'Dashboard',
    label: 'Dashboard',
  },
  {
    key: 'CommodityOverview',
    label: COMMODITY_OVERVIEW,
  },
  {
    key: 'ScenarioModel',
    label: SCENARIO_MODELLING,
  },
  {
    key: 'Tanso',
    label: 'Tanso',
  },
  {
    key: 'TansoApp',
    label: 'Tanso App',
  },
];
export const routerMenuItems: IHeaderMenuWithSubMenu[] = [
  { key: '0', label: 'Dashboard', path: '/Dashboard' },
  { key: '1', label: COMMODITY_OVERVIEW, path: '/CommodityOverView' },
  { key: '2', label: SCENARIO_MODELLING, path: '/ScenarioModel' },
  {
    label: 'NCF Reporting',
    key: '3',
    children: [
      { key: '3-1', label: 'View and Edit Report', path: '/viewEditReport' },
      { key: '3-2', label: 'Audit Report', path: '/viewauditreport' },
    ],
  },
];

export const FEEDBACK = 'Feedback';
export const HELP = 'Help';
export const HELP_LINK = 'https://eu001-sp.shell.com/:p:/r/sites/AAAAA0900/Documents/STSE_PRJ2154223_Carbon%20Management%20Framework/CPM/Product%20Management/User%20Instructions/CPM%20User%20Guide_June%202025.pptx?d=w78c9d7d287ba4c51859e830dba7433c0&csf=1&web=1&e=iPl5Mn';
export const FEEDBACK_LINK = 'https://forms.office.com/e/kwsN2g8rPe';
export const GLOBAL_REGION = 'GLOBAL';
export const COUNTRY_TITLE = 'MCR Ranking';
export const COUNTRY_CHART_SUBTITLE = 'A view of average Margin to Carbon Ratio (MCR) by Country.';
export const YAXIS_TEXT = 'Margin to Carbon Ratio (USD/Tonne)';
export const XAXIS_TEXT = 'Country';
export const LINE_CHART_TITLE = 'Planning MCR per IPU';
export const LINE_CHART_SUB_TITLE =
  'An overview of Margin to Carbon Ratio for each Integrated Performance Unit per year.';
export const LINE_CHART_YAXIS_TEXT = 'Margin to Carbon Ratio (USD/Tonne)';
export const API_ERROR = 'api is not available';
export const SE_IPU_REGION_TABLE_COLUMNS = [
  { label: 'IPU Region' },
  { label: 'Latest Estimate' },
  { label: 'Plan' },
  { label: 'Delta' },
];
export const COMMODITY_TABLE_COLUMNS = [
  { label: 'Commodity' },
  { label: 'Latest Estimate' },
  { label: 'Plan' },
  { label: 'Delta' },
];
export const SCENERIO_TABLE_SOURCE = 'Scenario Table';
export const SCENERIO_MODELLING_TITLE = SCENARIO_MODELLING;
export const SCENERIO_MODELLING_SUB_TITLE =
  'Use this tool to model different scenarios against the baseline portfolio to understand the carbon impact.';
export const COMMODITY_TITLE = COMMODITY_OVERVIEW;
export const COMMODITY_SUB_TITLE =
  'A detailed overview of a commodity that allows you to understand current inputs and performance.';
export const TITLE_FONT_FAMILY = 'Shell Font';
export const CHART_AXIS_STYLE = {
  fontFamily: TITLE_FONT_FAMILY,
  fontSize: '11px',
  fontWeight: '600',
  lineHeight: '16px',
  letterSpacing: '0em',
  textAlign: 'right',
  color: '#343434',
};

export const VIEW_DETAILS = 'View Details';
export const VIEW_IMPORTED_DEALS = 'View All Imported Deals';
export const point1 = 0.1;
export const point2 = 0.2;
export const point3 = 0.3;
export const point4 = 0.4;
export const point5 = 0.5;
export const point6 = 0.6;
export const point7 = 0.7;
export const point8 = 0.8;
export const point9 = 0.9;
export const zero = 0;
export const one = 1;
export const two = 2;
export const three = 3;
export const four = 4;
export const five = 5;
export const six = 6;
export const seven = 7;
export const eight = 8;
export const nine = 9;
export const ten = 10;
export const oneOne = 11;
export const hundred = 100;
export const fiveHundred = 500;
export const twoThousand = 2000;
export const oneTwoThree = 123;
export const oneTwo = 12;
export const power = 'Power';
export const naturalGas = 'Natural Gas';
export const pipeLineGas = 'Pipeline Gas';
export const renewableGas = 'Renewable Gas';
export const CarbonBudget = 'Carbon Budget';
export const pipeLineGasDeal = `${pipeLineGas} (Deal)`;
export const PLACEHOLDER_VALUE = 0.000001; // just to show the line on the chart, not the actual value
export const PIPELINE_GAS_DEAL = pipeLineGasDeal;
export const commodityOrder = [
  pipeLineGasDeal,
  'Power (Deal)',
  pipeLineGas,
  'Power',
  'Total Plan',
  'Latest Estimate (LE)',
];
export const IMPORTED_DEALS = 'Imported Deals';
export const colorMapping: { [key: string]: string } = {
  [`${pipeLineGas} (Americas)`]: '#D6A200',
  [`${pipeLineGas} (Europe)`]: '#FFC600',
  [`${pipeLineGas} (Asia)`]: '#FFDF55',
  [`${pipeLineGas} (Australia)`]: '#FFF7B4',
  'Power (Europe)': '#336094',
  'Power (Americas)': '#10355C',
  'Power (Asia)': '#6E94C0',
  'Power (Australia)': '#ACC3DE',
};

export const initialRegionData = {
  AMERICAS: {
    [`${pipeLineGas} (Americas)`]: [],
    'Power (Americas)': [],
  },
  ASIA: {
    [`${pipeLineGas} (Asia)`]: [],
    'Power (Asia)': [],
  },
  AUSTRALIA: {
    [`${pipeLineGas} (Australia)`]: [],
    'Power (Australia)': [],
  },
  EUROPE: {
    [`${pipeLineGas} (Europe)`]: [],
    'Power (Europe)': [],
  },
};

export const carbonBudgetLineData = {
  type: 'line',
  color: '#D93638',
  name: CarbonBudget,
  dashStyle: 'Dash',
  data: [],
};
export const regionOptions = ['ALL', 'Americas', 'Europe', 'Australia', 'Asia'];
export const SHELL_ENERGY_TRADING = 'Shell Energy Trading';
export const GAS_DISCLAIMER =
  'Please note Shell Energy Trading Actuals are currently missing for Asia.';
export const POWER_DISCLAIMER =
  'Please note that SET-A Actuals currently cover Japan and Philippines only.';
export const CONTRACTED_VS_PLAN_DISCLAIMER =
  'Please note contracted volumes are currently only available for Shell Energy Trading Americas, Europe/Africa and Japan.';
export const BASE_CASE_NCI = 'Base Case NCI';
export const SCENARIO_NCI = 'Scenario NCI';
export const NCI_RANGE = 'NCI Range';
export const BUSINESS_PLAN = 'Business Plan';
export const BUSINESS_PLAN_KEY = 'businessPlan';
export const DEAL_FUNNEL = 'Deal Funnel';
export const DEAL_FUNNEL_KEY = 'dealFunnel';
export const CARBON_LEAVERS = 'Carbon Levers';
export const CARBON_LEAVERS_KEY = 'carbonLeavers';
export const quarters = [
  { quarter: one, months: [two, three, four] },
  { quarter: two, months: [five, six, seven] },
  { quarter: three, months: [eight, nine, ten] },
  { quarter: four, months: [oneOne, oneTwo, one] },
];
export const BUSINESS_PLAN_TITLE =
  'Latest Operating Plan sales volumes of different commodities (aka Base Case). Modify them to build a scenario and visualize impact on Lifecycle Carbon Emissions.';
export const DEAL_FUNNEL_TITLE =
  'Funnel Deals activated on the Carbon KPI Calculator. Enable/disable them to build a scenario and visualize impact on Lifecycle Carbon Emissions.';

export const GAS_COMMODITY_ORDER = ['Renewable Gas', pipeLineGas];

export const MANUAL_LE_DATA = [
  {
    EVP: SUB_TITLE_DASHBOARD,
    Region: 'Americas',
    Volume: 47.39000000000000,
    'Volume UOM': 'TWH',
    Emission: 16.95000000000000,
    'Emission UOM': 'MTPA',
    Commodity: 'Power',
  },
  {
    EVP: SUB_TITLE_DASHBOARD,
    Region: 'Australia',
    Volume: 21.54000000000000,
    'Volume UOM': 'TWH',
    Emission: 18.26000000000000,
    'Emission UOM': 'MTPA',
    Commodity: 'Power',
  },
  {
    EVP: SUB_TITLE_DASHBOARD,
    Region: 'Europe',
    Volume: 14.070000000000000,
    'Volume UOM': 'TWH',
    Emission: 3.790000000000000,
    'Emission UOM': 'MTPA',
    Commodity: 'Power',
  },
  {
    EVP: SUB_TITLE_DASHBOARD,
    Region: 'Asia',
    Volume: 4.140000000000000,
    'Volume UOM': 'TWH',
    Emission: 0.040000000000000,
    'Emission UOM': 'MTPA',
    Commodity: 'Power',
  },
  {
    EVP: SHELL_ENERGY_TRADING,
    Region: 'Americas',
    Volume: 155.3000000000000,
    'Volume UOM': 'TWH',
    Emission: 74.89000000000000,
    'Emission UOM': 'MTPA',
    Commodity: 'Power',
  },
  {
    EVP: SHELL_ENERGY_TRADING,
    Region: 'Europe',
    Volume: 81.77000000000000,
    'Volume UOM': 'TWH',
    Emission: 16.94000000000000,
    'Emission UOM': 'MTPA',
    Commodity: 'Power',
  },
  {
    EVP: SHELL_ENERGY_TRADING,
    Region: 'Asia',
    Volume: 9.29000000000000,
    'Volume UOM': 'TWH',
    Emission: 6.190000000000000,
    'Emission UOM': 'MTPA',
    Commodity: 'Power',
  },
  {
    EVP: SUB_TITLE_DASHBOARD,
    Region: 'Americas',
    Volume: 0.000000000000000,
    'Volume UOM': 'TWH',
    Emission: 0.000000000000000,
    'Emission UOM': 'MTPA',
    Commodity: pipeLineGas,
  },
  {
    EVP: SUB_TITLE_DASHBOARD,
    Region: 'Australia',
    Volume: 6.500896000000000,
    'Volume UOM': 'TWH',
    Emission: 1.470000000000000,
    'Emission UOM': 'MTPA',
    Commodity: pipeLineGas,
  },
  {
    EVP: SUB_TITLE_DASHBOARD,
    Region: 'Europe',
    Volume: 102.225809,
    'Volume UOM': 'TWH',
    Emission: 21.630000000000,
    'Emission UOM': 'MTPA',
    Commodity: pipeLineGas,
  },
  {
    EVP: SHELL_ENERGY_TRADING,
    Region: 'Americas',
    Volume: 455.000000000000000,
    'Volume UOM': 'TWH',
    Emission: 100.0400000000000,
    'Emission UOM': 'MTPA',
    Commodity: pipeLineGas,
  },
  {
    EVP: SHELL_ENERGY_TRADING,
    Region: 'Australia',
    Volume: 14.480000000000000,
    'Volume UOM': 'TWH',
    Emission: 3.270000000000000,
    'Emission UOM': 'MTPA',
    Commodity: pipeLineGas,
  },
  {
    EVP: SHELL_ENERGY_TRADING,
    Region: 'Europe',
    Volume: 112.05000000000000,
    'Volume UOM': 'TWH',
    Emission: 23.7600000000000,
    'Emission UOM': 'MTPA',
    Commodity: pipeLineGas,
  },
  {
    EVP: SHELL_ENERGY_TRADING,
    Region: 'Asia',
    Volume: 7.126653000000000,
    'Volume UOM': 'TWH',
    Emission: 1.510000000000000,
    'Emission UOM': 'MTPA',
    Commodity: pipeLineGas,
  },
];

export const columnNames = [
  { header: 'Year', accessorKey: 'Year' },
  { header: 'Quantity', accessorKey: 'Quantity' },
  { header: 'Percentage', accessorKey: 'Percentage' },
];
export const viewTypeLevelOptions = [
  { label: 'CounterParty', value: 'allCptyLevel' },
  { label: 'NCF Category', value: 'ncfCategoryLevel' },
  { label: 'Country', value: 'countryLevel' },
];

export const devTeam = [
    'Md.M.Irfan@shell.com',
    'SK-Sabir.Ali@shell.com',
    'Jade-Nitish.Raj@shell.com',
    'Rama-Prasad.Nayak@shell.com',
  ];

export const userRoleForDevloper = [
  'SECPM_ITSupport_Global',
  'SECPM_Reporting_Asia',
  'SECPM_Reporting_Australia',
  'SECPM_Reporting_Europe',
  'SECPM_Reporting_Americas',
  'SECPM_NCFLead_Global',
  'SECPM_Team_Global',
  'SECPM_LT_Global',
  'SECPM_SE-VPGM_Americas',
  'SECPM_SE-VPGM_Asia',
  'SECPM_SE-VPGM_Australia',
  'SECPM_SE-VPGM_Europe',
  'SECPM_SET-VPGM_Americas',
  'SECPM_SET-VPGM_Asia',
  'SECPM_SET-VPGM_Australia',
  'SECPM_SET-VPGM_Europe',
  'SECPM_SU',
];

export const scenarioKpisOrder = [
  'External Gas Sales Volumes (Pipeline)',
  'External Gas Sales Volumes (Renewable)',
  'External Power Sales (Renewable CPPA)',
  'External Power Sales (non-CPPA REC)',
  'External Power Sales (GF Generation)',
  'External Power Sales (Other Non-Renewable Generation)',
  'External Power Sales (sourced from Grid)'
];

export const nonConversionRequiredUOMs = ['mtco2e'];
const SEEL_BELGIUM = 'SEEL Belgium';
const SEEL_FRANCE = 'SEEL France';
const SEEL_GERMANY = 'SEEL Germany';
const SEEL_ITALY = 'SEEL & EGO Italy';
const SEEL_NETHERLANDS = 'SEEL Netherlands';
const SEEL_SPAIN = 'SEEL Spain';
const SEEL_TURKEY = 'SEEL Turkey';
const SEEL_UK = 'SEEL UK';
const NEXT = 'NEXT';
export const hardCodedValueForSet2024Volume = [
  { 'reportingEntity': SEEL_BELGIUM, 'Renewable': 0.00515664251661927, 'Residual-Grid': 0.179539357483381 },
  { 'reportingEntity': SEEL_FRANCE, 'Renewable': 0.910913, 'Residual-Grid': 0.073689 },
  { 'reportingEntity': SEEL_GERMANY, 'Renewable': 0.0593865988514936, 'Residual-Grid': 2.06003240114851 },
  { 'reportingEntity': SEEL_ITALY, 'Renewable': 4.32970612718364, 'Residual-Grid': 1.95150187281636 },
  { 'reportingEntity': SEEL_NETHERLANDS, 'Renewable': 3.78685492326946, 'Residual-Grid': 2.21255507673054 },
  { 'reportingEntity': SEEL_SPAIN, 'Renewable': 2.56794431539677, 'Residual-Grid': 0.461929684603234 }
];
export const hardCodedValueForSet2024Emission = [
  { 'reportingEntity': SEEL_BELGIUM, 'Renewable': 0, 'Residual-Grid': 0.0195799287034951 },
  { 'reportingEntity': SEEL_FRANCE, 'Renewable': 0, 'Residual-Grid': 0.00368623122899061 },
  { 'reportingEntity': SEEL_GERMANY, 'Renewable': 0.00197522808769391, 'Residual-Grid': 1.85851043375979 },
  { 'reportingEntity': SEEL_ITALY, 'Renewable': 0, 'Residual-Grid': 0.956199578635478 },
  { 'reportingEntity': SEEL_NETHERLANDS, 'Renewable': 0.0439323871491038, 'Residual-Grid': 1.147314989327 },
  { 'reportingEntity': SEEL_SPAIN, 'Renewable': 0.0286293549020647, 'Residual-Grid': 0.0844822405161753 },
  { 'reportingEntity': SEEL_TURKEY, 'Renewable': 0, 'Residual-Grid': 0.020654336354841 },
  { 'reportingEntity': SEEL_UK, 'Renewable': 0.101102138462284, 'Residual-Grid': 7.86331204897311, 'Non-Renewable': 1.89363544491557 },
  { 'reportingEntity': NEXT, 'Renewable': 0.385788562272336, 'Residual-Grid': 4.28277351285971 }
];
export const hardCodedValueForSetIpuRegionLevel2024Volume = { 'Renewable': 39.03285, 'Residual-Grid': 36.87257, 'Non-Renewable': 3.782835 };
export const hardCodedValueForSetIpuRegionLevel2024Emission = { 'Renewable': 0.561427670873483, 'Residual-Grid': 16.2365133003586, 'Non-Renewable': 1.89363544491557 };

export const hardCodedValueForSetIpuRegionLevel2023Volume = { 'Renewable': 22.5097484569508, 'Residual-Grid': 29.9, 'Non-Renewable': 3.32 };
export const hardCodedValueForSetIpuRegionLevel2023Emission = { 'Renewable': 0.6111915028838, 'Residual-Grid': 13.05805, 'Non-Renewable': 1.6896 };
export const exampleData: Area[] = [
  {
    type: 'area',
    name: 'Hydrogen',
    data: [
      {
        yearType: '2023-plan',
        TRADE_YEAR: 2023,
        TRADE_COMMODITY_NAME: 'Hydrogen',
        CARBON_BUDGET: 685,
        CARBON_EMISSION: 0.006813,
        ORIGINAL_CARBON_EMISSION: 0.006813,
        QUANTITY: 13384.372178,
        SOURCE: 'PlanningOne',
        year: 2023,
        type: 'plan',
      },
    ],
  },
];

export const portfolioHradCodeDataFor2024 = [
  { year: 2024, nae: 0.019579929, reportingEntity: "SEEL Belgium" },
  { year: 2024, nae: 0.003686231, reportingEntity: "SEEL France" },
  { year: 2024, nae: 1.860485662, reportingEntity: "SEEL Germany" },
  { year: 2024, nae: 0.956199579, reportingEntity: "SEEL & EGO Italy" },
  { year: 2024, nae: 1.191247376, reportingEntity: "SEEL Netherlands" },
  { year: 2024, nae: 0.113111595, reportingEntity: "SEEL Spain" },
  { year: 2024, nae: 0.020654336, reportingEntity: "SEEL Turkey" },
  { year: 2024, nae: 9.858049632, reportingEntity: "SEEL UK" },
  { year: 2024, nae: 4.668562075, reportingEntity: "NEXT" }
];

export const portfolioHradCodeDataFor2023And2024 = [
  { year: 2023, nae: 15.3588415028838 },
  { year: 2024, nae: 18.6915764161476 },
];

export const REGIONS = ['AMERICAS', 'ASIA', 'AUSTRALIA', 'EUROPE', 'AFRICA', 'GLOBAL'];
export const TABITEMS = [
    { key: ALL_REGIONS, label: ALL_REGIONS },
    { key: 'AMERICAS', label: 'Americas' },
    { key: 'ASIA', label: 'Asia' },
    { key: 'AUSTRALIA', label: 'Australia' },
    { key: 'EUROPE', label: 'Europe' },
    // { key: 'GLOBAL', label: 'Global' }, // uncomment when it needs to be added.
  ];

  export const ERROR_FETCHING_PPT_DATA = 'Error fetching PPT data';
  export const UNKNOWN_ERROR = 'Unknown error';